// Copyright (c) 2017 Deere & Company

import ClaimSearch from './components';
import actionCreators from './action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    ...state.tcsm.addClaimsToAudit,
    auditClaims: state.tcsm.prepareAudit.auditPreparation.claims
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    const queryParams = parentProps.location;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        queryParams,
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(ClaimSearch);



// WEBPACK FOOTER //
// ./src/tcsm/claim-search/state-connector.js